import styles from './BrandLockup.module.css'

export function BrandLockup({ surface = 'auto', size = 'header' }: { surface?: 'light' | 'dark' | 'auto'; size?: 'header' | 'desktop' | 'mobile' }) {
  const wordmark = <span className={styles.wordmark}><strong>team</strong>centric</span>
  const product = <span className={styles.product}>Blueprint</span>

  return (
    <span className={`${styles.lockup} ${styles[surface]} ${styles[size]}`} aria-label={size === 'header' ? 'Blueprint' : 'teamcentric Blueprint'}>
      {size === 'header' ? product : <>{wordmark}{product}</>}
    </span>
  )
}
